import React, { useEffect } from 'react';
import Header from '@components/ui/Header';
import ServiceHero from './components/ServiceHero';
import Footer from '@components/ui/Footer';
import ServiceCategories from './components/ServiceCategories';
import ProcedureShowcase from './components/ProcedureShowcase';
import PatientTestimonials from './components/PatientTestimonials';
import PricingTransparency from './components/PricingTransparency';
import EmergencyEyeCare from './components/EmergencyEyeCare';
import ServiceCTA from './components/ServiceCTA';

const ServicesPage = () => {

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Update document title
    document.title = 'Our Services - Comprehensive Eye Care | Eye&U Kenya';

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        "Explore Eye&U Kenya's comprehensive eye care services, including advanced diagnostics, treatments, emergency care, and patient-centered solutions for all your vision needs."
      );
    }
  }, []);


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <ServiceHero />
        <ServiceCategories />
        {/* <ProcedureShowcase /> */}
        {/* <PatientTestimonials /> */}
        {/* <PricingTransparency /> */}
        {/*<EmergencyEyeCare /> */}
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;